import React, { useState, useEffect } from 'react';
import {imgItems as images } from '../datas/imgItems';
import styled from 'styled-components';

const Banners = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: clamp(24rem, 56vw, 34rem);
    background: #1A237E;
  
    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0;
        transform: scale(1.04);
        transition: opacity 1.2s ease, transform 3s ease;
        }
        
        img.active {
        opacity: 0.76;
        transform: scale(1);
        }

    &:after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(90deg, rgba(26, 35, 126, 0.7), rgba(26, 35, 126, 0.2));
        pointer-events: none;
    }

    @media screen and (max-width:770px) {
      height: 22rem;
    }
  
`

function Banner() {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex(prevIndex => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
      }, 3000); // Durée de 3 secondes
  
      return () => clearInterval(interval);
    }, []);
  
    return (
      <Banners>
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.image}
            alt={`pic-${image.id}`}
            className={index === currentIndex ? 'active' : ''}
          />
        ))}
      </Banners>
    );
}

export default Banner
